import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, CheckCircle2 } from 'lucide-react';
const ebooks = [{
  id: 1,
  title: 'De Ama de Casa a Dueña de Negocio',
  benefit: 'Rompe el miedo a cobrar y organiza tu tiempo entre los niños y los pedidos.',
  color: 'bg-rose-50 border-rose-200 text-rose-700'
}, {
  id: 2,
  title: 'Estrategia Instagram Paso a Paso',
  benefit: 'Deja de publicar fotos feas. Crea un perfil que venda solo mientras tú estás cocinando.',
  color: 'bg-blue-50 border-blue-200 text-blue-700'
}, {
  id: 3,
  title: 'El Arte de la Milhojas o Rogel',
  benefit: 'El clásico que nunca falla. Aprende el secreto del hojaldre que todos tus clientes recordarán.',
  color: 'bg-amber-50 border-amber-200 text-amber-700'
}, {
  id: 4,
  title: 'Postres en Vasitos (Sin Horno)',
  benefit: 'Mínimo esfuerzo, máxima ganancia. Ideales para eventos y entregas rápidas.',
  color: 'bg-emerald-50 border-emerald-200 text-emerald-700'
}, {
  id: 5,
  title: 'Cheesecake de Maracuyá (Sin Horno)',
  benefit: 'El postre más instagrameable y refrescante que se vende solo en verano.',
  color: 'bg-yellow-50 border-yellow-200 text-yellow-700'
}, {
  id: 6,
  title: 'Pavlova con Frutas Frescas',
  benefit: 'Elegancia pura. Un postre ligero que te posiciona como repostera de alto nivel.',
  color: 'bg-purple-50 border-purple-200 text-purple-700'
}, {
  id: 7,
  title: 'Tarta Ópera (Pastelería Francesa)',
  benefit: 'La joya de la corona. Cobra el doble por esta pieza de arte.',
  color: 'bg-purple-50 border-purple-200 text-purple-700'
}, {
  id: 8,
  title: 'Kit del Primer Cliente — Postres que Sí se Venden',
  benefit: 'Tu hoja de ruta para conseguir tu primer cliente real. Incluye los postres más vendidos y cómo cerrar tu primera venta.',
  color: 'bg-chocolate text-cream border-chocolate-light'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function ValueStack() {
  return <section className="py-20 px-4 bg-white relative overflow-hidden" data-id="element-196">
      {/* Decorative divider top */}
      <div className="absolute top-0 left-0 w-full h-4 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTAgMTBjNSAwIDEwLTEwIDIwLTEwdjEwSDB6IiBmaWxsPSIjRkRGQkY3IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4=')] bg-repeat-x rotate-180" data-id="element-197" />

      <div className="max-w-5xl mx-auto" data-id="element-198">
        <div className="text-center mb-16" data-id="element-199">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-chocolate mb-6" data-id="element-200">
            Todo lo que incluye el{' '}
            <span className="text-rose-600" data-id="element-201">Bundle Completo</span>
          </h2>
          <p className="text-lg text-chocolate-light" data-id="element-202">
            8 Guías Maestras diseñadas para resultados rápidos.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-203">
          {ebooks.map((ebook, index) => <motion.div key={ebook.id} variants={itemVariants} className={`
                relative p-6 md:p-8 rounded-2xl border-2 shadow-sm
                flex flex-col gap-4 transition-transform hover:-translate-y-1
                ${ebook.id === 7 ? 'md:col-span-2 md:flex-row md:items-center' : ''}
                ${ebook.color}
              `} data-id="element-204">
              <div className="flex items-center gap-4 mb-2 md:mb-0" data-id="element-205">
                <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center font-serif font-bold text-xl shrink-0" data-id="element-206">
                  #{ebook.id}
                </div>
                <h3 className="font-serif text-xl md:text-2xl font-bold leading-tight" data-id="element-207">
                  {ebook.title}
                </h3>
              </div>

              <div className={`flex items-start gap-3 ${ebook.id === 7 ? 'md:ml-auto md:max-w-md' : ''}`} data-id="element-208">
                <CheckCircle2 className="w-6 h-6 shrink-0 mt-0.5 opacity-80" data-id="element-209" />
                <p className="text-base md:text-lg font-medium opacity-90" data-id="element-210">
                  {ebook.benefit}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}